<template>
  <div>
    <LoaderCircle class="h-8 w-8 animate-spin text-microsoft-blue-default mb-2" />
    <p class="text-base text-neutral-gray-700">
      {{ loading }}
    </p>
  </div>
</template>

<script>
import { LoaderCircle } from 'lucide-vue'

export default {
  components: {
    LoaderCircle,
  },
  props: {
    loading: {
      type: String,
      required: true,
    },
  },
}
</script>
